import axios from "axios";

import { reducerGetAccess, reducerSetAccessRequestStatus } from "../../reducer/tunder/reducers/reducerAccess";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetAccess =
  (limit: number, offset: number) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/tander/settings?offset=${offset}&limit=${limit}`
      );
      dispatch(reducerGetAccess({ data: response.data, limit, offset }));
    } catch {
      console.log("err");
    }
  };

export const actionEditAccess =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const formattedData = {
      ...data,
      contract: {
        id: data.contract.value,
      },
    };
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/tander/settings`,
        formattedData
      );
      dispatch(reducerSetAccessRequestStatus(response.status));
      dispatch(actionGetAccess(10, 0));
    } catch {
      console.log("err");
    }
  };

export const actionAddAccess = (data: any) => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const formattedData = {
    ...data,
    contract: {
      id: data.contract.value,
    },
  };
  try {
    const response = await axios.put(
      `${BASE_URL}/json/tander/settings`,
      formattedData
    );
    dispatch(actionGetAccess(10, 0));
    dispatch(reducerSetAccessRequestStatus(response.status));
  } catch {
    console.log("err");
  }
};
